import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";
import { getPreferredPhone, useGetAllContacts } from "@api/contactService";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        cell: (row, {LinkComponent}) => {
            return (<>
                {row.name !== row.company_name && (<>
                    <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
                    </LinkComponent>
                    {row.company_name && (<Typography fontSize="sm">{row.company_name}</Typography>)}
                </>)}
                {row.name === row.company_name && (<>
                    <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    <Typography fontWeight={'bold'}>{row.company_name}</Typography>
                    </LinkComponent>
                </>)}
            </>)
        }
    },
    {
        id: 'phone',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Phone',
        cell: (row) => getPreferredPhone(row),
    },
];

export default function ContactListWidget(props) {
    return (
        <ListWidget
            query={useGetAllContacts}
            columns={columns}
            {...props}
            title={'Contact List'}
        />
    );
}
